import { render, staticRenderFns } from "./EfsCapSubjectItemList.vue?vue&type=template&id=28fc205b&scoped=true&"
import script from "./EfsCapSubjectItemList.vue?vue&type=script&lang=js&"
export * from "./EfsCapSubjectItemList.vue?vue&type=script&lang=js&"
import style0 from "./EfsCapSubjectItemList.vue?vue&type=style&index=0&id=28fc205b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fc205b",
  null
  
)

export default component.exports